export const FILE_SIZE_5MB = 5 * 1024 * 1024; // 5 Megabytes in bytes
